import type { ReactNode } from 'react';
import { cn } from '@shared/lib';

interface DividerProps {
  children?: ReactNode;
  className?: string;
}

export function Divider({ children, className }: DividerProps) {
  if (!children) {
    return <div className={cn('h-px bg-line', className)} />;
  }
  return (
    <div
      className={cn(
        'flex items-center gap-3 text-[12px] font-medium uppercase tracking-[0.14em] text-muted',
        'before:h-px before:flex-1 before:bg-line after:h-px after:flex-1 after:bg-line',
        className,
      )}
    >
      {children}
    </div>
  );
}
